var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaMalgruppe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#eff2fa;}.cls-4{fill:#009bd9;}.cls-5{fill:#76b72a;}.cls-6{fill:#ea5c0b;}.cls-7{fill:#f2c136;}.cls-8{fill:#f7cf9c;}.cls-9{fill:#d8a373;}.cls-10{fill:#3d4a5c;}.cls-11{fill:#d83d3d;}.cls-12{fill:#b72c2c;}.cls-13{fill:#23303f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.41,
    y: 8,
    width: 141.19,
    height: 144
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Malgruppe"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124.44,65.24a50.17,50.17,0,0,1-9.18,3.4l-.73.18a45.78,45.78,0,0,1-19.76.76C85.86,67.82,79.12,63,77.29,56.11c-2.42-9.13,4.42-19.26,16.1-25.5a9.89,9.89,0,0,0,5.19-7.91,10.44,10.44,0,0,0-9-11.2C82,10.5,71.05,10,60.23,12.85,23.87,22.48,2.37,60.72,11.5,97.2a70.05,70.05,0,0,0,138-16.46c0-.25,0-.52,0-.82a17.48,17.48,0,0,0-25.05-14.68Zm-3,42.71a10.15,10.15,0,1,1,7.21-12.41A10.15,10.15,0,0,1,121.47,108Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.3,123.4A12.4,12.4,0,1,1,90.9,111a12.4,12.4,0,0,1,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68.46,114.77a12.41,12.41,0,1,1-12.4-12.4,12.4,12.4,0,0,1,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.84,84.52a12.4,12.4,0,1,1-12.4-12.4,12.4,12.4,0,0,1,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.2,49.57a12.41,12.41,0,1,1-12.4-12.4,12.4,12.4,0,0,1,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.07,64.44,140,91.19l-4.43,56.75a3.89,3.89,0,0,1-2,2.89A8.58,8.58,0,0,1,129,152c-3.49,0-6.35-1.83-6.51-4.12l-4-56.78-1.86-26.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.15,151.48c-2.29-.62-3.94-2.07-4.06-3.8l-4.24-83.31-7.16,0,1.86,26.77,4,56.78c.16,2.29,3,4.1,6.51,4.12a9.23,9.23,0,0,0,3.14-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M140,91.19l2.09-26.75-18.22-.07-7.16,0,1.86,26.77,6.66,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M116.69,64.34c-11.61-5.22-12.83-22.68-2.45-33S129.18,15,129.21,8c0,0,37.42,38.33,12.86,56.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M127.2,64.38l-10.51,0c-11.61-5.22-12.83-22.67-2.45-33S129.18,15,129.21,8c3.75,20.71-17.09,33-2,56.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M125.21,91.12l-1.36-26.75-7.16,0,1.86,26.77Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaMalgruppe);
export default __webpack_public_path__ + "static/media/ka_malgruppe.293fb06f3044c2617a421048e57e6184.svg";
export { ForwardRef as ReactComponent };